export const environment = {
  production: false,
  config: 'assets/config/config.json'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts